import MasterTemplatesPage from './MasterTemplatesPage';
import { MASTER_TEMPLATES } from './masterTemplates.navigation';

const MASTER_TEMPLATES_ROUTE = { ...MASTER_TEMPLATES, component: MasterTemplatesPage };

export default MASTER_TEMPLATES_ROUTE;
